import React from "react";
import HeroSection from "./HeroSection/HeroSection";
import UserTypeSection from "./UserTypeSection/UserTypeSection";
import TrialBox from "./TrialBox/TrialBox";
import StatsSection from "./StatsSection/StatsSection";
import Partners from "./Partners/Partners";
import TalepFormu from "./TalepFormu/TalepFormu";

const HomePage = () => {
  return (
    <div>
      <HeroSection />
      <UserTypeSection />
      <TrialBox/>
      <StatsSection/>
      <Partners/>
      <TalepFormu/>
    </div>
  );
};

export default HomePage;
